import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateVehicleDamageDto } from '../../dtos/create-vehicle-damage.dto';
import { UpdateVehicleDamageDto } from '../../dtos/update-vehicle-damage.dto';
import { createVehicleDamageSchema } from '../schemas/create-vehicle-damage.schema';
import { updateVehicleDamageSchema } from '../schemas/update-vehicle-damage.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateVehicleDamageDto | UpdateVehicleDamageDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateVehicleDamageSchema if 'id' is present
		validationResult = updateVehicleDamageSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createVehicleDamageSchema if 'id' is not present
		validationResult = createVehicleDamageSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
